<template>
  <div>
    <v-app-bar dense dark>
      <v-btn icon>
        <router-link :to="{name: 'Apps'}">
          <v-icon color="white">mdi-home</v-icon>
        </router-link>
      </v-btn>

      <div @click="goBack" v-if="this.$route.path != '/'">
        <v-btn icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>

      <v-toolbar-title>{{$route.name}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on, attrs }">
          <v-icon dark v-bind="attrs" v-on="on">mdi-account-circle</v-icon>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
              <v-list-item-subtitle>You are the supreme force.</v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="logout">Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      message: false,
      hints: true,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
